'use client';
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var focusRing = function(theme) {
    return function(options) {
        var _theme_palette_primary;
        var _ref = options || {}, _ref_color = _ref.color, color = _ref_color === void 0 ? (_theme_palette_primary = theme.palette.primary) == null ? void 0 : _theme_palette_primary.mid : _ref_color, _ref_visible = _ref.visible, visible = _ref_visible === void 0 ? true : _ref_visible, selector = _ref.selector, styles = _ref.styles;
        var finalSelector = selector ? selector : visible ? "&:focus-visible" : "&:focus";
        var _obj;
        return _obj = {}, _obj[finalSelector] = _extends({
            outline: "none",
            boxShadow: "0 0 0 " + theme.focusWidth + " " + color,
            transitionDuration: "200ms",
            transitionProperty: "box-shadow",
            transitionTimingFunction: theme.timingFunction
        }, styles), _obj;
    };
};

export { focusRing };
